/**!*******************************************************************
 *
 * Copyright (c) Epic AI GmbH. All rights reserved.
 * Author:  Alexander Claas
 *
 ********************************************************************!*/

import { CommitOptions, DispatchOptions, Module, ModuleTree } from "vuex";
import { state, IRootState } from "./state";
import { getters, IGetters } from "./getters";
import { IMutations, mutations } from "./mutations";
import { actions, IActions } from "./actions";
import { Store as VuexStore } from "vuex";

import { user } from "../user";
import { admin } from "../admin";
import { bot } from "../bot";
import { inbox } from "../inbox";

//Modules
const modules: ModuleTree<IRootState> = {
  user,
  admin,
  bot,
  inbox,
};

// Module
export const root: Module<IRootState, IRootState> = {
  state,
  getters,
  mutations,
  actions,
  modules,
};

// Store type
export type RootStoreModuleTypes<S = IRootState> = Omit<
  VuexStore<S>,
  "commit" | "getters" | "dispatch"
> & {
  commit<K extends keyof IMutations, P extends Parameters<IMutations[K]>[1]>(
    key: K,
    payload?: P,
    options?: CommitOptions
  ): ReturnType<IMutations[K]>;
} & {
  getters: {
    [K in keyof IGetters]: ReturnType<IGetters[K]>;
  };
} & {
  dispatch<K extends keyof IActions>(
    key: K,
    payload?: Parameters<IActions[K]>[1],
    options?: DispatchOptions
  ): ReturnType<IActions[K]>;
};
